import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-pie-chart-cnp',
  templateUrl: './pie-chart-cnp.component.html',
  styleUrls: ['./pie-chart-cnp.component.scss']
})
export class PieChartCNPComponent implements OnInit, OnChanges {

  @Input() data = [];

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {

    this.pieChartLabels = [];
    this.pieChartData = [];

    if (Number(changes.data.currentValue[0].firmas_contratos_exitosos) > 0) {
      this.pieChartLabels.push(["Exitosos"]);
      this.pieChartData.push(changes.data.currentValue[0].firmas_contratos_exitosos);
    }

    if (Number(changes.data.currentValue[0].firmas_contratos_fallidos) > 0) {
      this.pieChartLabels.push(["Fallidos"]);
      this.pieChartData.push(changes.data.currentValue[0].firmas_contratos_fallidos);
    }

  }

  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return label;
        },
      },
    }
  };

  public pieChartLabels = [];
  public pieChartData = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];
  public pieChartColors = [
    {
      backgroundColor: ['rgba(0,255,0,0.3)', 'rgba(255,0,0,0.3)'],
    }
  ];
}
